import agent from 'superagent';
export class NlpClient {
    constructor(apiEndpoint) {
        this.apiEndpoint = apiEndpoint;
        this.apiEndpoint = this.apiEndpoint.replace(/\/+$/, '');
    }
    /** Check if the service is healthy */
    async isHealthy() {
        return this.getHealth()
            .then(({ status }) => status === 'up')
            .catch(() => false);
    }
    /**  Get the API version */
    async getVersion() {
        const { version } = await this.getHealth();
        return version;
    }
    /**
     * Split the given text into their its sentence representation
     * @param text The raw text
     * @param [mode='spacy'] The mode
     */
    async splitTextIntoSentences(text, mode = 'spacy') {
        const { body } = await agent.post(`${this.apiEndpoint}/sentence-segmentation`).send({ mode, text });
        return body.sentences;
    }
    /**
     * Clean the given tweets removing links, hashtags, mentions and emojis. Cleansed tweets are returned in the same order
     * @param tweets List of tweets to clean
     */
    async preprocessTweets(tweets) {
        const { body } = await agent.post(`${this.apiEndpoint}/tweet-preprocessing`).send({ tweets });
        return body.preprocessed_tweets;
    }
    /**
     * Clean the given sentences by removing trailing artifacts, such as question (P.) and reply (R.) signals
     * @param sentences List of sentences to clean
     */
    async preprocessEditorText(sentences) {
        const { body } = await agent.post(`${this.apiEndpoint}/editor-preprocessing`).send({ sentences });
        return body.preprocessed_sentences;
    }
    /**
     * Detect the language and return the language name or the language ISO-639 depending on the format param.
     * The languages are returned in the same position in the array as the corresponding sentence
     * @param sentences The target sentences
     * @param [format] The language format
     */
    async detectLanguage(sentences, format) {
        const { body } = await agent.post(`${this.apiEndpoint}/detect-language`).send({ sentences }).query({ format });
        return body.languages;
    }
    getHealth() {
        return agent.get(`${this.apiEndpoint}/_health`).then(({ body }) => body);
    }
}
